import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ArrowLeftIcon } from 'lucide-react';
import AuthLayout from '../components/AuthLayout';
const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const {
    requestPasswordReset,
    isLoading
  } = useAuth();
  const navigate = useNavigate();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!email) {
      setError('Please enter your email address');
      return;
    }
    try {
      const result = await requestPasswordReset(email);
      if (result) {
        // Navigate to OTP verification page with email and reset mode flag
        navigate('/otp-verification', {
          state: {
            email,
            resetMode: true
          }
        });
      } else {
        setError('No account found with this email address');
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
    }
  };
  return <AuthLayout title="Reset Password" subtitle="Get back into your account" data-id="element-316">
      <div className="mt-8 space-y-6" data-id="element-317">
        <div data-id="element-318">
          <Link to="/login" className="flex items-center text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors mb-6" data-id="element-319">
            <ArrowLeftIcon className="w-4 h-4 mr-1" data-id="element-320" />
            Back to login
          </Link>
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-321">
            Forgot your password?
          </h2>
          <p className="mt-2 text-sm text-gray-600" data-id="element-322">
            Enter your email address and we'll send you a verification code to
            reset your password
          </p>
        </div>
        {error && <div className="p-4 rounded-md bg-red-50 text-red-700" data-id="element-323">{error}</div>}
        {success && <div className="p-4 rounded-md bg-green-50 text-green-700" data-id="element-324">
            {success}
          </div>}
        <form className="space-y-6" onSubmit={handleSubmit} data-id="element-325">
          <div data-id="element-326">
            <label htmlFor="email-address" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-327">
              Email address
            </label>
            <input id="email-address" name="email" type="email" autoComplete="email" required className="appearance-none block w-full px-4 py-3 border border-gray-300 rounded-lg placeholder-gray-400 focus:outline-none focus:ring-teal-500 focus:border-teal-500 transition-all" placeholder="you@example.com" value={email} onChange={e => setEmail(e.target.value)} data-id="element-328" />
          </div>
          <div data-id="element-329">
            <button type="submit" disabled={isLoading} className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-lg text-white bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500 transition-all disabled:opacity-70" data-id="element-330">
              {isLoading ? <span className="flex items-center" data-id="element-331">
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-332">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-333"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-334"></path>
                  </svg>
                  Sending...
                </span> : 'Send Reset Instructions'}
            </button>
          </div>
        </form>
      </div>
    </AuthLayout>;
};
export default ForgotPassword;